import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../components/Header";
import api, { errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function Verify() {
  const { token } = useParams();
  const [state, setState] = useState("pending"); // pending | ok | error
  const [message, setMessage] = useState("");
  const { refresh } = useAuth();

  useEffect(() => {
    if (!token) return;
    (async () => {
      try {
        const r = await api.post(`/auth/verify/${token}`);
        if (r.data?.joined_teams?.length) {
          localStorage.setItem("welcomeTeams", JSON.stringify(r.data.joined_teams));
        }
        setState("ok");
        setMessage(r.data?.email || "");
        // A signed-in user's "verify your email" banner reads the auth
        // context; reload it so the banner goes away without a page reload.
        // Signed out, this just confirms there is no session.
        refresh();
      } catch (err) {
        setState("error");
        setMessage(errMsg(err, "Verification failed"));
      }
    })();
  }, [token, refresh]);

  return (
    <div className="min-h-screen">
      <Header />
      <main id="main" tabIndex={-1} className="max-w-md mx-auto px-6 py-16 text-center">
        <div className="marquee-tag mb-4">// EMAIL VERIFICATION</div>
        {state === "pending" && (
          <>
            <Loader2 size={48} className="mx-auto mb-6 animate-spin" />
            <h1 className="font-display font-black type-title tracking-tighter mb-2">CHECKING…</h1>
            <p className="text-ink-muted">Confirming your verification link.</p>
          </>
        )}
        {state === "ok" && (
          <div data-testid="verify-success">
            <CheckCircle2 size={56} className="mx-auto mb-6 text-ink-accent" />
            <h1 className="font-display font-black type-title tracking-tighter mb-2">EMAIL CONFIRMED.</h1>
            {message && <p className="text-ink-muted font-mono-ui text-sm mb-6">{message}</p>}
            <Link to="/dashboard" className="brutal-btn mt-4 inline-flex">Go to dashboard</Link>
          </div>
        )}
        {state === "error" && (
          <div data-testid="verify-error">
            <XCircle size={56} className="mx-auto mb-6 text-ink-muted" strokeWidth={1.5} />
            <h1 className="font-display font-black type-title tracking-tighter mb-2">LINK INVALID.</h1>
            <p className="text-ink-muted mb-6">{message}</p>
            <Link to="/dashboard" className="brutal-btn brutal-btn-secondary mt-4 inline-flex">Go to dashboard</Link>
          </div>
        )}
      </main>
    </div>
  );
}
